import { render, staticRenderFns } from "./MilestoneProgressBar.vue?vue&type=template&id=2a724d4c&scoped=true&"
import script from "./MilestoneProgressBar.vue?vue&type=script&lang=js&"
export * from "./MilestoneProgressBar.vue?vue&type=script&lang=js&"
import style0 from "./MilestoneProgressBar.vue?vue&type=style&index=0&id=2a724d4c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a724d4c",
  null
  
)

export default component.exports